import { useState, useCallback } from "react";

type NavigationAction = "close" | "newChat" | "switchSession";

interface PendingAction {
  action: NavigationAction;
  callback: () => void;
}

export function useGenerationWarning() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [pendingAction, setPendingAction] = useState<PendingAction | null>(null);

  const checkGenerationAndExecute = useCallback(
    (
      isGenerating: boolean,
      action: NavigationAction,
      callback: () => void
    ) => {
      if (isGenerating) {
        // Show warning dialog
        setPendingAction({ action, callback });
        setIsDialogOpen(true);
      } else {
        // Execute immediately if not generating
        callback();
      }
    },
    []
  );

  const handleConfirm = useCallback(() => {
    if (pendingAction) {
      pendingAction.callback();
      setPendingAction(null);
    }
    setIsDialogOpen(false);
  }, [pendingAction]);

  const handleCancel = useCallback(() => {
    setPendingAction(null);
    setIsDialogOpen(false);
  }, []);

  return {
    isDialogOpen,
    setIsDialogOpen,
    pendingAction,
    checkGenerationAndExecute,
    handleConfirm,
    handleCancel,
  };
} 